import { AIconProps } from '../../atoms/AIcon/AIcon.types';
import { ALabelProps } from '../../atoms/ALabel/ALabel.types';

export enum MTagType {
  Default = 'Default',
  Inverse = 'Inverse',
  Accent = 'Accent',
  Alternate = 'Alternate',
  Overlay = 'Overlay',
}

export interface MTagProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: MTagType;
  aIcon?: AIconProps;
  aLabel: ALabelProps;
}
